<template>
  <section class="about">
    <div class="container">
      <p>This page is under construction.</p>
      <router-link to="/"><i class="fas fa-long-arrow-alt-left me-3"></i>Home</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "Help",
};
</script>
